import './YourSteps.css'
import Navbar from '../components/Navbar'
import { useState, useEffect } from "react";
import { URL, ALL_LOCATIONS } from "../components/constants";
import iconsave from '../assets/images/iconsave.svg'

export default function YourSteps() {
  const [stepsData, setStepsData] = useState({}); // saved steps
  const [inputValues, setInputValues] = useState({}); // typing state
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({}); // track per-day saving status
  const [error, setError] = useState("");

  // ShitPost states
  const [shitPost, setShitPost] = useState("");
  const [shitPostInput, setShitPostInput] = useState("");
  const [shitPostSaving, setShitPostSaving] = useState(false);

  // generate all dates from today back to Jan 1, 2026
  const generateDates = () => {
    const dates = [];
    const today = new Date();
    const start = new Date("2026-01-01");
    for (let d = today; d >= start; d.setDate(d.getDate() - 1)) {
      dates.push(d.toISOString().slice(0, 10)); // YYYY-MM-DD
    }
    return dates;
  };
  const allDates = generateDates();

  // fetch existing steps
  useEffect(() => {
    const fetchSteps = async () => {
      try {
        const res = await fetch(`${URL}/steps`, { credentials: "include" });
        const data = await res.json();
        const stepsMap = {};
        data.forEach(item => {
          stepsMap[item.day] = item.miles;
        });
        setStepsData(stepsMap);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    const fetchShitPost = async () => {
      try {
        const res = await fetch(`${URL}/shitpost`, { credentials: "include" });
        const data = await res.json();
        setShitPost(data.message || "");
        setShitPostInput(data.message || "");
      } catch (err) {
        console.error(err);
      }
    };

    fetchSteps();
    fetchShitPost();
  }, []);

  const handleInputChange = (date, value) => {
    setInputValues(prev => ({ ...prev, [date]: value }));
  };

  const handleSave = async (date) => {
    const miles = Number(inputValues[date] ?? stepsData[date] ?? 0);
    setSaving(prev => ({ ...prev, [date]: true }));
    setError("");
    try {
      const res = await fetch(`${URL}/steps`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ date, miles }),
      });
      if (!res.ok) throw new Error("Failed to save");

      setStepsData(prev => ({ ...prev, [date]: miles }));
      setInputValues(prev => ({ ...prev, [date]: undefined }));
    } catch (err) {
      console.error(err);
      setError(`Error saving ${date}`);
    } finally {
      setSaving(prev => ({ ...prev, [date]: false }));
    }
  };

  const handleShitPostSave = async () => {
    setShitPostSaving(true);
    setError("");
    try {
      const res = await fetch(`${URL}/shitpost`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ message: shitPostInput }),
      });
      if (!res.ok) throw new Error("Failed to save shitpost");

      setShitPost(shitPostInput);
    } catch (err) {
      console.error(err);
      setError("Error saving shitpost");
    } finally {
      setShitPostSaving(false);
    }
  };

  if (loading) return <div><Navbar /></div>;

  // calculate total miles
  let totalMiles = 0;
  Object.values(stepsData).forEach(value => {
    totalMiles += Number(value) || 0;
  });

  // determine current and next location
  let atLocation = ALL_LOCATIONS[0];
  let nextLocation = null;
  for (let i = 1; i < ALL_LOCATIONS.length; i++) {
    if (totalMiles < ALL_LOCATIONS[i].miles) {
      atLocation = ALL_LOCATIONS[i - 1];
      nextLocation = ALL_LOCATIONS[i];
      break;
    }
    if (i === ALL_LOCATIONS.length - 1) {
      atLocation = ALL_LOCATIONS[i];
    }
  }

  return (
    <div>
      <Navbar />
      <h1 style={{ flexBasis: "100%", textAlign: "center", marginTop:"40px" }}>
        miles walked to mordor
      </h1>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className="walk-description">
        <img src={atLocation.sprite} className="description-image" alt={atLocation.name}/>
        <p>
          You have walked <b>{(totalMiles).toFixed(2)} mi</b>.<br/><br/>
          {nextLocation ? (
            <>You have <b>{(nextLocation.miles - totalMiles).toFixed(2)} miles</b> to go until you reach {nextLocation.name}.</>
          ) : (
            <>You have reached the final location: {atLocation.name}!</>
          )}
        </p>
        {nextLocation?.sprite && (
          <img src={nextLocation.sprite} className="description-image" alt={nextLocation.name}/>
        )}
      </div>

      <div className="shitpost-container">
        <h3>Unleash your Battlecry: </h3>
        <textarea
          value={shitPostInput}
          onChange={(e) => setShitPostInput(e.target.value)}
          className="shitpost-textarea"
          placeholder="AAAHHHHHHHHHHHHHHHHHHHHHHHH"
        />
        <div className="save-button-wrapper">
          <button
            onClick={handleShitPostSave}
            disabled={shitPostSaving || shitPostInput === shitPost}
            className="steps-save-btn"
            style={{
              visibility: shitPostInput !== shitPost ? "visible" : "hidden"
            }}
          >
            <img src={iconsave} alt="" />
          </button>
        </div> 
      </div>

      <div className="daily-steps-container">
        <div className="steps-list">
          {allDates.map(date => {
            const currentValue = inputValues[date] ?? stepsData[date] ?? "";
            const showSave = currentValue !== (stepsData[date] ?? "");
            return (
              <div key={date} className="steps-row">
                <span className="steps-date">{date}</span>
                <div className="steps-input-container">
                  <input
                    type="number"
                    min="0"
                    value={currentValue}
                    onChange={(e) => handleInputChange(date, e.target.value)}
                    className="steps-input"
                  />
                  {showSave && (
                    <button
                      onClick={() => handleSave(date)}
                      disabled={saving[date]}
                      className="steps-save-btn"
                    >
                      <img src={iconsave} alt="" />
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}